<script setup lang="ts">
import AlertHistory from '@/alert/components/alertDetail/AlertHistory.vue';
import NotificationStatusWindow from '@/alert/components/notificationStatusWindow/NotificationStatusWindow.vue';
import AlertInsightView from '@/alert/components/alertDetail/AlertInsightView.vue';
import AlertAiAnalysis from '@/alert/components/alertDetail/AlertAiAnalysis.vue';
import { Props, setup } from './eventAlertDetail.setup';
import EventAlertInformation from './EventAlertInformation.vue';

const props = defineProps<Props>();

const {
  selectedTab,
  tabPanels,
  targetInfo,
  eventData,
  ruleData,
  notificationStatusWindowInfo,
  isTabLoading,
  onChangeLoadingState,
  onClickStatusIcon,
  isFetching,
  aiAnalysisContext,
} = setup(props);
</script>

<template>
  <div class="event-alert-detail">
    <ev-tabs
      v-model="selectedTab"
      :panels="tabPanels"
      :class="['event-alert-detail__tabs', selectedTab]"
      stretch
    >
      <ev-tab-panel
        v-for="item in tabPanels"
        :key="item.value"
        :text="item.text"
        :value="item.value"
        lazy
      >
        <event-alert-information
          v-if="item.value === 'information'"
          :is-show="selectedTab === 'information'"
          :event-data="eventData"
          :rule-data="ruleData"
          :target-info="targetInfo"
          :is-fetching="isFetching"
          @change-loading="onChangeLoadingState"
          @on-click-status-icon="onClickStatusIcon"
        />

        <alert-history
          v-if="item.value === 'history'"
          v-model:is-loading="isTabLoading"
          :is-show="selectedTab === 'history'"
        />
        <alert-insight-view
          v-if="item.value === 'insightView'"
          :is-show="selectedTab === 'insightView'"
        />
        <alert-ai-analysis
          v-if="item.value === 'aiAnalysis'"
          :is-show="selectedTab === 'aiAnalysis'"
          :context="aiAnalysisContext"
          detailed
          auto-load-cache
        />
      </ev-tab-panel>
    </ev-tabs>
    <notification-status-window
      v-model:is-show="notificationStatusWindowInfo.isShow"
      :available-status="notificationStatusWindowInfo.availableStatus"
      :initial-selected-type="notificationStatusWindowInfo.selectedType"
      :result-id="notificationStatusWindowInfo.resultId"
      :time-period-info="targetInfo.timePeriodInfo"
    />
  </div>
</template>

<style lang="scss">
.event-alert-detail {
  height: 100%;
  min-height: 0;

  &__tabs {
    height: 100%;
    min-height: 0;

    .ev-tabs-body {
      height: calc(100% - 31px);
      min-height: 0;
    }

    &.information > .ev-tabs-body {
      overflow-y: auto;
    }

    &.information .ev-tab-panel {
      height: auto !important;
      min-height: 0;

      // 프로세스 목록 채우기 이벤트(--fill 섹션 포함)일 때만 패널을 채워 프로세스 목록 flex:1이 동작
      &:has(.event-alert-information--fill) {
        height: 100% !important;
      }
    }

    &.history > .ev-tabs-body {
      padding: 16px 0 0 !important;
    }

    &.history .ev-tab-panel {
      height: 100%;
      min-height: 0;
    }

    &.insightView > .ev-tabs-body {
      padding: 0;
    }
    &.insightView .ev-tab-panel {
      height: 100%;
      min-height: 0;
      padding: 12px;
      overflow: auto;
    }
  }
}
</style>
